export default __webpack_public_path__ + "images/7N.27b6cba.png";